import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { PermissionService } from "../../services/permission.service";

@Component({
  selector: "app-unauthorized",
  templateUrl: "./unauthorized.component.html",
  styleUrls: ["./unauthorized.component.css"],
})
export class UnauthorizedComponent {
  currentRole: string;

  constructor(
    private router: Router,
    private permissionService: PermissionService
  ) {
    this.currentRole = this.permissionService.getCurrentRole();
  }

  goBack() {
    window.history.back();
  }

  goHome() {
    this.router.navigate(["/userhome"]);
  }
}
